import { render, staticRenderFns } from "./FormUpload.vue?vue&type=template&id=0a36f3ee&"
import script from "./FormUpload.vue?vue&type=script&lang=js&"
export * from "./FormUpload.vue?vue&type=script&lang=js&"
import style0 from "./FormUpload.vue?vue&type=style&index=0&id=0a36f3ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports